import {
  IonButton,
  IonButtons,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonRadio,
  IonRadioGroup,
  IonToolbar,
  useIonLoading
} from '@ionic/react'
import { arrowBack } from 'ionicons/icons'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import claroLogo from '../../assets/images/claro.png'
import loginImg from '../../assets/images/logo.png'
import Button from '../../components/Button'
import { useAppContext } from '../../context/AppContext'
import useMessages from '../../hooks/useMessages'
import useValidate from '../../hooks/useValidate'
import { getSettings } from '../../services/api/dig-documents-manager/index'
import { loginPy } from '../../services/api/portabilidad-api/index'

const LoginPY = () => {
  const [present, dismiss] = useIonLoading()
  const { setUser, setLoginScreen, setSettings }: any = useAppContext()
  const history = useHistory()
  const initialState = {
    typeKiosk: '',
    typeCode: '',
    username: '',
    password: ''
  }
  const { validate } = useValidate()
  const [loginStep, setLoginStep] = useState(1)
  const [isError, setIsError] = useState(initialState)
  const [loginCredentials, setLoginCredentials] = useState(initialState)
  const [validatedCredentials, setValidatedCredentials] = useState({ username: '', password: '' })
  const typeValidity = !loginCredentials.typeKiosk

  useEffect(() => {
    setLoginScreen(true)
  }, [])

  const { toastMessage } = useMessages()

  const nextStep = () => {
    setLoginStep(2)
  }

  const handleTypeKiosk = (event: any) => {
    setLoginCredentials({
      ...loginCredentials,
      typeKiosk: event.detail.value,
      typeCode: event.detail.value === 'PDA' ? 'POS' : 'PTU'
    })
  }

  const goBack = () => {
    setLoginStep(1)
    setLoginCredentials(initialState)
    setValidatedCredentials({ username: '', password: '' })
    setIsError(initialState)
  }

  const clearError = (event: any) => {
    const inputName = event.target.name
    setIsError({
      ...isError,
      [inputName]: ''
    })
    if (event.target.name === 'username') event.target?.parentElement.classList.remove('error')
    event.target?.parentElement.parentElement.classList.remove('error')
  }

  const handleError = (event: any) => {
    const validateIfPDA = loginCredentials.typeKiosk === 'PDA'
    const inputName = event.target.name
    const inputValue = event.target.value
    const inputError = validate(inputValue, inputName, validateIfPDA)

    if (inputError) {
      if (event.target.name === 'username') event.target?.parentElement.classList.add('error')
      else event.target?.parentElement.parentElement.classList.add('error')
      setIsError({
        ...isError,
        [inputName]: inputError
      })
    }
  }

  const handleInput = (event: any) => {
    const inputName = event.target.name
    const inputValue = inputName === 'password' ? event.detail.value : event.target.value

    setLoginCredentials({
      ...loginCredentials,
      [inputName]: inputValue
    })
    validateInputs(event)
  }

  const validateInputs = (event: any) => {
    const validateIfPDA = loginCredentials.typeKiosk === 'PDA'
    const inputName = event.target.name
    const inputValue = inputName === 'password' ? event.detail.value : event.target.value

    const inputError = validate(inputValue, inputName, validateIfPDA)
    if (!inputError) {
      clearError(event)
      setValidatedCredentials({
        ...validatedCredentials,
        [inputName]: inputValue
      })
    } else
      setValidatedCredentials({
        ...validatedCredentials,
        [inputName]: ''
      })
  }

  const handleLogin = async () => {
    present({
      message: `Iniciando sesión. <br/> Esperá por favor.`
    })
    try {
      const [loginData, frontSettings] = await Promise.all([
        loginPy({
          typeKiosk: loginCredentials.typeKiosk,
          pinNumber: loginCredentials.password,
          posPtuNumber:
            loginCredentials.typeKiosk === 'PDA' ? loginCredentials.username : loginCredentials.username.slice(1)
        }),
        getSettings()
      ])
      if (!loginData.success) throw new Error(loginData.message)
      setUser({ ...loginData.response })
      localStorage.setItem('user', JSON.stringify({ ...loginData.response }))
      if (!frontSettings.success) throw new Error('No se pudieron obtener las settings')
      setSettings(frontSettings.response)
      localStorage.setItem('settings', JSON.stringify(frontSettings.response))

      setLoginStep(1)
      setLoginCredentials(initialState)
      setValidatedCredentials({ username: '', password: '' })
      history.push('/procedures')
      setLoginScreen(false)
    } catch (error: any) {
      toastMessage(error.message, 3000, 'bottom', 'error')
    } finally {
      dismiss()
    }
  }

  const validity = Object.values(validatedCredentials).some((value) => !value)

  const mainHeader = (
    <div>
      <img src={loginImg} style={{ height: '150px' }} />
      <h3>Iniciar sesión</h3>
    </div>
  )

  const selectTypeKiosk = (
    <section className="login-container">
      {mainHeader}
      <h5>
        <strong>Ingresá tu tipo de kiosco</strong>
      </h5>
      <IonList className="login-list">
        <IonRadioGroup value={loginCredentials.typeKiosk} onIonChange={handleTypeKiosk}>
          <IonItem>
            <IonLabel>Puntos de Activaciones</IonLabel>
            <IonRadio slot="start" value="PDA"></IonRadio>
          </IonItem>

          <IonItem>
            <IonLabel>Puntos de Venta</IonLabel>
            <IonRadio slot="start" value="PDV"></IonRadio>
          </IonItem>

          <IonItem>
            <IonLabel>Puntos de Giros</IonLabel>
            <IonRadio slot="start" value="PDG"></IonRadio>
          </IonItem>

          <IonItem>
            <IonLabel>Vendedor Directa</IonLabel>
            <IonRadio slot="start" value="VD"></IonRadio>
          </IonItem>
        </IonRadioGroup>
      </IonList>
      <div className="login-action">
        <Button
          id="continue-to-login-form"
          className="submit-button"
          label="Ingresar"
          validity={typeValidity}
          handleSubmit={nextStep}
        />
      </div>
    </section>
  )

  const insertLoginData = (
    <section className="login-container">
      {mainHeader}
      <h5>Por favor ingresá tus credenciales</h5>
      <form noValidate>
        <div className="group">
          <label className="group-label">Número de {loginCredentials.typeKiosk === 'PDA' ? 'POS' : 'PTU'}</label>
          <input
            className="group-input input-new"
            placeholder={loginCredentials.typeKiosk === 'PDA' ? 'XXXXXX' : '09XXXXXXXX'}
            name="username"
            value={loginCredentials.username}
            type="text"
            inputMode="numeric"
            max={10}
            onChange={handleInput}
            onBlur={handleError}
            onFocus={clearError}
            autoComplete="username"
          />
        </div>
        <span className="input-error">{isError.username}</span>
        <div className="group">
          <label className="group-label">Pin</label>
          <IonInput
            className="group-input"
            placeholder="XXXX"
            name="password"
            value={loginCredentials.password}
            type="password"
            inputMode="numeric"
            maxlength={4}
            onIonChange={handleInput}
            onBlur={handleError}
            onFocus={clearError}
            autocomplete="current-password"
          />
        </div>
        <span className="input-error">{isError.password}</span>
      </form>
      <div className="login-action">
        <Button
          id="login-user"
          className="submit-button"
          label="Ingresar"
          validity={validity}
          handleSubmit={handleLogin}
        />
      </div>
    </section>
  )

  return (
    <>
      <header>
        <IonToolbar>
          <IonButtons slot="start" hidden={loginStep === 1}>
            <IonButton onClick={goBack}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <img src={claroLogo} className={`max-height-22 ${loginStep === 1 && 'ion-padding-start'}`} />
        </IonToolbar>
      </header>
      <main className="login">
        {loginStep === 1 && selectTypeKiosk}
        {loginStep === 2 && insertLoginData}
      </main>
    </>
  )
}

export default LoginPY
